import React, { useState } from 'react';
import { useEffectOnce } from 'react-use';
import LoadingSpinner from '@grnhse/seedling/lib/birch/components/loading_spinner';
import FullWidth from '@grnhse/seedling/lib/birch/layouts/full_width';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';

import { withLocalePrefix } from 'shared/utils/translation';
const t = withLocalePrefix('talent_matching');

const RankingLoader = () => {
  const messages = ['parsing', 'calculating', 'checking', 'calibrating'];

  const [currentMessage, setCurrentMessage] = useState(0);

  useEffectOnce(() => {
    const incrementMessage = () => {
      setCurrentMessage((prev) => (prev + 1 < messages.length ? prev + 1 : 0));
    };
    const intervalId = setInterval(incrementMessage, 1500);

    return () => {
      clearInterval(intervalId);
    };
  });

  const spinnerMessage = t(`table.loading_spinner.${messages[currentMessage]}`);

  return (
    <Stack direction="row" alignItems="center" sx={{ minHeight: '500px' }}>
      <FullWidth>
        <Stack spacing={2} alignItems="center">
          <LoadingSpinner size="medium" />
          <SecondaryBody>{`${spinnerMessage}...`}</SecondaryBody>
        </Stack>
      </FullWidth>
    </Stack>
  );
};

export default RankingLoader;
